<div
  #dialog
  aria-describedby="extsite-flyout-modal-content"
  aria-labelledby="modalTitle"
  class="extsite-flyout container content mt-0 border-top-0"
  role="dialog"
  tabindex="0"
>
  <div class="extsite-flyout">
    <div class="mt-0 border-0">
      <div class="modal-header">
        <h4 [innerHTML]="axPopupContent?.popupTitle" class="title"></h4>
        <span class="sr-only" id="modalTitle">
          {{ axPopupContent?.popupTitle }}
        </span>
      </div>
      <div id="extsite-flyout-modal-content">
        <div class="modal-body pl-0">
          <div [innerHTML]="axPopupContent?.popupDesc"></div>
          <div
            [innerHTML]="axPopupContent?.popupQuestion"
            class="d-block footer-question"
          ></div>
        </div>
        <div
          class="modal-footer justify-content-lg-end justify-content-md-center pl-0 border-0"
        >
          <button
            (click)="close()"
            class="btn-keep btn btn-outline-secondary-cta rounded-0 icon-close"
          >
            {{ axPopupContent?.primaryLabel }}
          </button>
          <a
            (click)="openInNewTab()"
            class="btn-extsite btn btn-danger rounded-0"
            href="javascript:void(0);"
          >
            {{ axPopupContent?.secondaryLabel }}
            <span class="sr-only">Opens in a new window.</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
